'use strict';

angular.module('uniromaLandingApp')
    .factory('ConfigParam', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/configParams/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);
